module.exports = __webpack_public_path__ + "img/404.953dd785.png";